import React from 'react';
import './order-card.scss';
import { SVGS } from '../../assets';
import '../../conversations/_conversation-utils.scss';
import { MessageKebabMenu } from '../message-kebab-menu/message-kebab-menu';
import { getFormattedAmount } from '@zonofi/common';
import { useNavigate } from 'react-router-dom';
import { FIELD_OPS_ROUTES } from '../../constants';

export const OrderCardComp: React.FC<{
  id: string;
  time: string;
  orderNumber: string;
  skus: number;
  amount: number;
  msgs?: string[];
  img?: string;
}> = ({ id, time, orderNumber, skus, amount, msgs, img }) => {
  const navigate = useNavigate();
  const onClickSubmit = () => {
    navigate(FIELD_OPS_ROUTES.ORDER_DETAILS + '/' + id);
  };

  console.log('id : ', id, ' rendering order card');

  return (
    <div className="order-card-comp">
      <div className="order-card-comp__header">
        <div className="order-card-comp__header-left">
          <span className="font-semibold order-card-comp__header-left-title">
            <img src={SVGS.CartBlue} alt="" />
            Order Placed
          </span>
          <div className={`order-card-comp-status-details`}>Draft</div>
        </div>
        <div className="order-card-comp__header-right">
          <div className="font-regular order-card-comp__header-right-time">
            <img src={SVGS.Clock} alt="" /> {time}
          </div>
          <MessageKebabMenu />
        </div>
      </div>
      <div className="order-card-comp__body-wrapper">
        <div className="order-card-comp__body-wrapper-msgs">
          {msgs?.map((msg) => {
            return (
              <div className="order-card-comp-message-with-image">
                {img ? (
                  <img
                    src={'https://picsum.photos/241/122'}
                    alt=""
                    className=""
                  />
                ) : null}
                <span className="message-with-image-message font-regular">
                  {msg}
                </span>
              </div>
            );
          })}
        </div>
        <img src={SVGS.Whatsapp} alt="" width={24} />
      </div>

      <div className="order-card-comp__extra-details">
        <div className="order-card-comp__extra-details-item">
          <div className="order-card-comp__extra-details-item-heading">
            Order Id
          </div>
          <div className="order-card-comp__extra-details-item-value">#{id}</div>
        </div>
        <div className="order-card-comp__extra-details-item">
          <div className="order-card-comp__extra-details-item-heading">
            SKUs
          </div>
          <div className="order-card-comp__extra-details-item-value">
            {skus}
          </div>
        </div>
        <div className="order-card-comp__extra-details-item">
          <div className="order-card-comp__extra-details-item-heading">
            Order Amount
          </div>
          <div className="order-card-comp__extra-details-item-value">
            {getFormattedAmount(amount)}
          </div>
        </div>
      </div>
      <div className="order-card-comp__footer">
        <span className="order-status font-regular">
          Your action is required!
        </span>
        <button
          className="btn btn-primary font-regular"
          onClick={onClickSubmit}
        >
          Submit Order <img src={SVGS.ArrowDown} />
        </button>
      </div>
    </div>
  );
};
